import { render, staticRenderFns } from "./MultipleProductsCol.vue?vue&type=template&id=2b577f5f&scoped=true"
import script from "./MultipleProductsCol.vue?vue&type=script&lang=js"
export * from "./MultipleProductsCol.vue?vue&type=script&lang=js"
import style0 from "./MultipleProductsCol.vue?vue&type=style&index=0&id=2b577f5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b577f5f",
  null
  
)

export default component.exports